import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row, Form, Button, Image } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { formatInputDate } from "../../utils/Time";
import { calculator } from "../../utils/Calculator";
import { PDFInputFile, PDFPreviewFile } from "../PDFFileHandler";
import { MediaUploader, MediaPreviewer } from "../MediaUploader";
import {
  autoDisplayValue,
  formatCurrency,
  formatCurrencyToNumber,
  formatFileName,
  plusStringValue
} from "../../commons/FormatValue";
import {
  initializeSetOption,
  initializeSetOptionMulti
} from "../../utils/InitializeSetDefault";
import {
  filteredIndex,
  filteredItemInArray,
  filteredNoneItemInArray,
  filteredNoneMultiItemInArray,
  findItemInArray
} from "../../utils/ManageArray";
import {
  AddIcon,
  AttachFileIcon,
  DeleteIcon,
  GooglePinIcon,
  PreviewIcon
} from "../../data/iconImage";
import {
  deleteServiceRequest,
  getServiceRequest,
  addEditServiceRequest
} from "../../commons/ServiceRequest";
import {
  FloatingControlComponent,
  FormCheckComponent,
  SearchSelectComponent
} from "../FormComponent";
import TableForm from "../TableForm";
import SearchFilter from "../SearchFilter";
import ConfirmModal from "../ConfirmModal";
import CardDisplayComponent from "../CardDisplayComponent";
import ItemsService from "../../services/item.service";
import JobTypeService from "../../services/jobtype.service";
import CustomersService from "../../services/customer.service";
import EmployeesService from "../../services/employee.service";
import ItemOthersService from "../../services/itemother.service";
import JobTypeSubService from "../../services/jobTypeSub.service";
import FileUploadsService from "../../services/fileupload.service";
import CustContractsService from "../../services/custcontract.service";
import JobOtherPricesService from "../../services/jobotherprice.service";
import InformOtherJobsService from "../../services/informotherjob.service";
import CustContractItemsService from "../../services/custcontractitem.service";
import InformOtherJobFilesService from "../../services/informotherjobfile.service";

const CreateJobForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { loading, setLoading } = useLoading(false);
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [PDFPreview, setPDFPreview] = useState(false);
  const [Items, setItems] = useState([]);
  const [Branch, setBranch] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [Customer, setCustomer] = useState([]);
  const [department, setDepartment] = useState([]);
  const [to_Section, setTo_Section] = useState([]);
  const [JobTypeSub, setJobTypeSub] = useState([]);
  const [CustContracts, setCustContracts] = useState([]);
  const [employee_Name, setEmployee_Name] = useState([]);
  const [employee_Name2, setEmployee_Name2] = useState([]);
  const [InformOtherJobs, setInformOtherJobs] = useState([]);
  const [CustContractItems, setCustContractItems] = useState([]);
  const [dateTime, setDateTime] = useState({ date: null, time: null });

  const [dateTimeInform, setDateTimeInform] = useState({
    date: null,
    time: null
  });
  const searchInput = [
    {
      name: "Id",
      labelName: "Inform_Doc_No",
      label: "หมายเลขแจ้งงาน",
      filterBy: ["Inform_Doc_No"],
      value: `${state?.searchValue}`
    }
  ];
  const defaultData = {
    Inform: {
      Com_Code: user.Com_Code,
      Attach_File: null,
      BP_Code: null,
      Conclusion_List: null,
      Contract_No: null,
      Cus_Contract_Name1: null,
      Cus_Contract_Tel1: null,
      Cus_Contract_Name2: null,
      Cus_Contract_Tel2: null,
      Cus_Id: null,
      Cus_NumBranch: null,
      Cus_Cpec_Tex: null,
      Employee_Id: null,
      GoogleMap_Link: null,
      Inform_By_Id: null,
      Inform_Doc_Date: !editData ? new Date().toISOString() : null,
      Inform_Doc_No: null,
      Inform_Doc_Status: !editData ? "OPEN" : null,
      Inform_Section: null,
      JobList1: null,
      JobList2: null,
      JobList3: null,
      JobList4: null,
      JobList5: null,
      JobList6: null,
      JobList7: null,
      JobList8: null,
      Job_Type_Id: null,
      Job_Type_Sub_Id: null,
      Job_Cus_Date: "",
      Job_Name: null,
      Non_PM_List: null,
      PM_List: null,
      Project_No: null,
      Ref_Doc_Date: null,
      Ref_Doc_No: null,
      Remark: null,
      Service_Call: null,
      Sub_Team: null,
      To_Section: "Other"
    },
    Item: {
      Com_Code: user.Com_Code,
      Job_Other_Id: null,
      Item_Id: null,
      Item_Serial: null,
      Item_Install_Qty: null,
      Uom_Unit: null,
      Item_Price_Per_Unit: null,
      Item_Amount: null,
      Item_Price_Unit: null
    },
    Job: {
      Com_Code: user.Com_Code,
      Job_Other_Id: null,
      Oth_Des: null,
      Oth_Price: null,
      Oth_Price_Unit: null,
      Remark: null
    }
  };
  const [data, setData] = useState({
    Inform: { Array: [defaultData.Inform] },
    Item: { Array: [defaultData.Item] },
    Job: { Array: [defaultData.Job] },
    Media: { Image: [], Video: [] }
  });
  const rowInform = data?.Inform?.Array?.[0];
  const [uploadFile, setUploadFile] = useState({
    PDF: null,
    Image: [],
    Video: []
  });
  const inputField = {
    Inform: [
      {
        name: "Inform_Doc_No",
        label: "หมายเลขแจ้งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        disabled: true
      },
      {
        name: "Ref_Doc_No",
        label: "เลขที่อ้างอิง",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: "1_5",
        required: true
      },
      {
        name: "Ref_Doc_Date",
        label: "วันที่อ้างอิง",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: "1_5",
        required: true,
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "Job_Type_Id",
        label: "ประเภทงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5",
        required: true,
        noneAsync: true,
        filterBy: ["Job_Type_Name"],
        options: initializeSetOption({
          key: "Id",
          label: "Job_Type_Name",
          dataset: JobType
        })
      },
      {
        name: "Job_Type_Sub_Id",
        label: "ประเภทงานย่อย",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5",
        required: true,
        noneAsync: true,
        filterBy: ["Job_Type_Sub_Name"],
        options: initializeSetOption({
          key: "Id",
          label: "Job_Type_Sub_Name",
          dataset: filteredItemInArray(
            JobTypeSub,
            "Job_Type_Id",
            rowInform?.Job_Type_Id
          )
        })
      },
      {
        name: "Inform_Doc_Date",
        label: "วันที่แจ้งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: "1_75",
        readOnly: !editData,
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "Inform_Doc_Date",
        label: "",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "time",
        size: "1_25",
        readOnly: !editData,
        format: (value) => value && formatInputDate(value, "Local")?.time
      },
      {
        name: "Cus_Id",
        label: "รหัสลูกค้าหลัก (BP Master Code)",
        classNames: { col: "mb-3", label: "mb-1" },
        filterBy: ["Cus_Code"],
        options: initializeSetOption({
          key: "Id",
          label: "Cus_Code",
          dataset: Customer
        }),
        queryService: (query) => {
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: CustomersService.getAllCustomers(query),
            callback: ({ items }) => setCustomer(items)
          });
        }
      },
      {
        name: "Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        readOnly: true,
        findValue: { data: Customer, key: "Id", value: "Cus_Id" },
        size: 3
      },
      {
        name: "Project_No",
        label: "หมายเลขโครงการ",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: "1_5",
        findValue: {
          data: CustContracts,
          key: "Contract_No",
          value: "Contract_No"
        },
        readOnly: true
      },
      {
        name: "Service_Call",
        label: "Call No.",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        readOnly: true,
        size: "1_5"
      },
      {
        name: "Job_Cus_Date",
        label: "วันที่นัดหมายลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: "1_75",
        required: true,
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "Job_Cus_Date",
        label: "",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "time",
        size: "1_25",
        required: true,
        readOnly: rowInform?.Job_Cus_Date === "",
        format: (value) => value && formatInputDate(value, "Local")?.time
      },
      {
        name: "Cus_Address",
        label: "ที่อยู่",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: 6,
        disabled: true,
        plusString: {
          plusValue: [
            "Cus_Road",
            "Cus_District",
            "Cus_SubDistrict",
            "Cus_Province",
            "Cus_ZipCode"
          ],
          operator: " ",
          data: findItemInArray(Customer, "Id", rowInform?.Cus_Id)
        }
      },
      {
        name: "Cus_Contract_Tel1",
        label: "เบอร์โทรผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        readOnly: !!editData
      },
      {
        name: "Cus_Contract_Name1",
        label: "ผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        readOnly: !!editData
      },
      {
        name: "BP_Code",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: null,
        filterBy: ["Cus_Code"],
        options: initializeSetOption({
          key: "Id",
          label: "Cus_Code",
          dataset: Branch
        })
      },
      {
        name: "Cus_NumBranch",
        label: "เลขที่สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: "1_25",
        disabled: true,
        findValue: { data: Branch, key: "Id", value: "BP_Code" }
      },
      {
        name: "Cus_Name",
        label: "ชื่อสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: null,
        disabled: true,
        findValue: { data: Branch, key: "Id", value: "BP_Code" }
      },
      {
        name: "Cus_Contract_Tel2",
        label: "เบอร์โทรผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        findValue: { data: Branch, key: "Id", value: "BP_Code" }
      },
      {
        name: "Cus_Contract_Name2",
        label: "ผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        findValue: { data: Branch, key: "Id", value: "BP_Code" }
      },
      {
        name: "Cus_Address",
        label: "สถานที่จัดส่งสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: 9,
        readOnly: !editData,
        plusString: {
          plusValue: [
            "Cus_Road",
            "Cus_District",
            "Cus_SubDistrict",
            "Cus_Province",
            "Cus_ZipCode"
          ],
          operator: " ",
          data: findItemInArray(Branch, "Id", rowInform?.BP_Code)
        }
       
      },
      {
        name: "Inform_Doc_Status",
        label: "สถานะใบแจ้งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: !editData && "text",
        readOnly: true,
        noneAsync: true,
        options: [
          { value: "OPEN", label: "OPEN" },
          { value: "CANCEL", label: "CANCEL" },
          { value: "CLOSED", label: "CLOSED" }
        ]
      },
      {
        name: "Job_Name",
        label: "ชื่องาน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: 9,
        required: true
      },
      {
        name: "To_Section",
        label: "ถึงแผนก",
        classNames: { col: "mb-3", label: "mb-1" },
        required: true,
        minKeywordLength: 1,
        filterBy: ["Employee_Department"],
        options: [
          ...initializeSetOption({
            key: "Employee_Department",
            dataset: to_Section
          }),
          { value: "Other", label: "Other" }
        ],
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) => setTo_Section(items)
          })
      },
      {
        name: "Attach_File",
        label: "ไฟล์แนบ( PDF )",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: "7_25",
        readOnly: true,
        format: (value) => formatFileName(value)
      },
      {
        name: "PreviewButton",
        type: "button",
        size: "0_67",
        disabled: rowInform?.Attach_File === null,
        icon: { src: PreviewIcon, alt: "Preview Icon" },
        onClick: () => setPDFPreview(!PDFPreview)
      },
      {
        name: "DeleteButton",
        type: "button",
        size: "0_67",
        disabled: rowInform?.Attach_File === null,
        icon: { src: DeleteIcon, alt: "Delete Icon" },
        onClick: () => handleDeleteFileUploadPDF(rowInform?.Attach_File)
      },
      {
        name: "AttachButton",
        type: "button",
        size: "0_67",
        disabled: rowInform?.Attach_File !== null,
        icon: { src: AttachFileIcon, alt: "Attach File Icon" }
      },
      {
        name: "Cus_ContactEmail",
        label: "Email",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        disabled: true,
        findValue: { data: Customer, key: "Id", value: "Cus_Id" }
      },
      { name: "GoogleMap_Link", label: "Google Map", type: "text", size: null },
      {
        name: "GoogleMapButton",
        classNames: { col: "w-auto" },
        type: "button",
        size: "0_67",
        icon: { src: GooglePinIcon, alt: "Google Pin Icon" },
        onClick: () =>
          window.open(
            rowInform?.GoogleMap_Link || "https://www.google.com/maps",
            "_blank"
          )
      },
      {
        name: "Employee_Id",
        label: "ชื่อทีม/หัวหน้าช่าง",
        classNames: { col: "mb-3", label: "mb-1" },
        required: true,
        minKeywordLength: 1,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: filteredNoneItemInArray(
            employee_Name,
            "Id",
            rowInform?.Inform_By_Id
          )
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) => setEmployee_Name(items)
          })
      },
      {
        name: "Remark",
        label: "หมายเหตุ",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: 12
      },
      {
        name: "Subject_Inform",
        label: "เรื่องที่แจ้ง",
        type: "text",
        size: 12,
        required: true
      }
    ],
    Inform5: [
      {
        name: "Cus_Cpec_Tex",
        label: "คำสั่งเพิ่มเติม (ลูกค้า)",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: 12
      }
    ],
    Item: [
      {
        name: "Item_Id",
        label: "รหัสสินค้า/อะไหล่/อุปกรณ์",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "select",
        size: 2,
        noneRequired: true,
        filterBy: ["Item_Code"],
        options: initializeSetOption({
          key: "Id",
          label: "Item_Code",
          dataset: Items
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: ItemsService.getAllItems(query),
            callback: ({ items }) => setItems(items)
          })
      },
      {
        name: "Item_Name_TH",
        label: "รายละเอียดสินค้า/อะไหล่/อุปกรณ์",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: 2,
        findValue: { data: Items, key: "Id", value: "Item_Id" },
        readOnly: true,
        noneRequired: true
      },
      {
        name: "Item_Install_Qty",
        label: "จำนวน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        format: (row) => formatCurrency(row.Item_Install_Qty || ""),
        noneRequired: true
      },
      {
        name: "Unit",
        label: "หน่วย",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        findValue: { data: Items, key: "Id", value: "Item_Id" },
        readOnly: true,
        noneRequired: true
      },
      {
        name: "Item_Price_Per_Unit",
        label: "ราคา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        format: (row) => formatCurrency(row.Item_Price_Per_Unit || ""),
        noneRequired: true
      },
      {
        name: "Item_Amount",
        label: "ราคารวม",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        format: (row) => formatCurrency(row.Item_Amount || ""),
        readOnly: true,
        noneRequired: true,
        sumValue: {
          firstName: "Item_Install_Qty",
          secondName: "Item_Price_Per_Unit",
          operator: "*"
        }
      },
      {
        name: "Item_Price_Unit",
        label: "สกุลเงิน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        noneRequired: true
      }
    ],
    Job: [
      {
        name: "Oth_Des",
        label: "รายการค่าบริการ",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        noneRequired: true
      },
      {
        name: "Oth_Price",
        label: "ราคา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        format: (row) => formatCurrency(row.Oth_Price || ""),
        noneRequired: true
      },
      {
        name: "Oth_Price_Unit",
        label: "สกุลเงิน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        noneRequired: true
      },
      {
        name: "Remark",
        label: "หมายเหตุ",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        noneRequired: true
      }
    ],
    Radio: [
      { name: "PM_List", label: "มี PM" },
      { name: "PM_List", label: "ไม่มี PM" },
      { name: "PM_List", label: "รอสรุป" }
    ],
    Maintenance: [
      {
        name: "Contract_No",
        label: "เลขที่สัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4,
        filterBy: ["Contract_No"],
        options: initializeSetOption({
          key: "Contract_No",
          dataset: CustContracts
        }),
        queryService: (query) => {
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: CustContractsService.getAllCustContracts(query),
            callback: ({ items }) =>
              setCustContracts(
                filteredItemInArray(items, "Cus_Id", rowInform?.Cus_Id)
              )
          });
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest:
              CustContractItemsService.getAllCustContractItems(query),
            callback: ({ items }) =>
              setCustContractItems(filteredItemInArray(items))
          });
        }
      },
      {
        name: "Contract_Start_Date",
        label: "วันที่เริ่มต้นสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: 4,
        disabled: true,
        findValue: {
          data: CustContracts,
          key: "Contract_No",
          value: "Contract_No"
        },
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "Contract_End_Date",
        label: "วันที่สิ้นสุดสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: 4,
        disabled: true,
        findValue: {
          data: CustContracts,
          key: "Contract_No",
          value: "Contract_No"
        },
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "PM_Per_Year",
        label: "จำนวน PM/ปี",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        findValue: {
          data: CustContractItems,
          key: "Contract_No",
          value: "Contract_No"
        },
        disabled: true,
        size: 4
      },
      {
        name: "Inform_By_Id",
        label: "ผู้แจ้ง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4,
        minKeywordLength: 1,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: filteredNoneItemInArray(
            employee_Name2,
            "Id",
            rowInform?.Employee_Id
          )
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) => setEmployee_Name2(items)
          })
      },
      {
        name: "Inform_Section",
        label: "แผนกที่แจ้ง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4,
        minKeywordLength: 1,
        filterBy: ["Employee_Department"],
        options: initializeSetOption({
          key: "Employee_Department",
          dataset: department
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) => setDepartment(items)
          })
      }
    ],
    Checkbox: [
      { name: "JobList1", label: "สำรวจหน้างาน" },
      { name: "JobList2", label: "งานรื้อถอน" },
      { name: "JobList3", label: "ติดตั้ง" },
      { name: "JobList4", label: "เทสระบบ" },
      { name: "JobList5", label: "Training/ส่งมอบ" },
      { name: "JobList6", label: "เก็บน้ำ" }
    ]
  };

  const InputSearch = (field, dataField) => {
    return (
      <Row>
        {field.map(
          (
            {
              name,
              label,
              classNames,
              type,
              size,
              icon,
              options,
              filterBy,
              noneAsync,
              queryService,
              minKeywordLength,
              format,
              findValue,
              disabled,
              readOnly,
              required,
              onClick,
              placeholder,
              plusString
            },
            idx
          ) => {
            const rowField = data?.[dataField]?.Array?.[0];
            const result =
              (name === "Attach_File" && formatFileName(rowField?.[name])) ||
              (format && format(rowField?.[name])) ||
              (plusString &&
                plusStringValue(
                  plusString?.plusValue,
                  plusString?.operator,
                  plusString?.data
                )) ||
              (findValue &&
                autoDisplayValue({
                  name,
                  type,
                  findValue: {
                    ...findValue,
                    value: rowField?.[findValue?.value || findValue?.key]
                  }
                })) ||
              rowField?.[name] ||
              "";

            const setDateTimeUpdate = (val) => {
              const dateTimeUpdate =
                name === "Inform_Doc_Date" ? dateTimeInform : dateTime;
              const fieldUpdate = label !== "" ? "date" : "time";
              const updatedDateTime = { ...dateTimeUpdate, [fieldUpdate]: val };

              name === "Inform_Doc_Date"
                ? setDateTimeInform(updatedDateTime)
                : setDateTime(updatedDateTime);
            };

            return (
              <Col
                key={idx}
                sm={size === null ? null : size || 3}
                className={classNames?.col}
              >
                {type ? (
                  type === "button" ? (
                    name === "AttachButton" ? (
                      <PDFInputFile
                        onFileChange={handleUploadFilePDF}
                        button={{
                          color: "outline-secondary",
                          className: "mt-2 p-2 rounded-circle",
                          icon,
                          disabled,
                          style: { width: "45px" }
                        }}
                      />
                    ) : (
                      <Button
                        variant="outline-secondary"
                        className="my-2 px-2 rounded-circle"
                        disabled={disabled}
                        onClick={onClick}
                        style={{ width: "45px" }}
                      >
                        <Image src={icon?.src} alt={icon?.alt} />
                      </Button>
                    )
                  ) : (
                    <FloatingControlComponent
                      type={type}
                      name={name}
                      label={label}
                      placeholder="โปรดระบุ"
                      disabled={disabled}
                      readOnly={readOnly}
                      required={required}
                      className={classNames}
                      onChange={({ target }) =>
                        ["Inform_Doc_Date", "Job_Cus_Date"].includes(name)
                          ? setDateTimeUpdate(target.value)
                          : handleChange(dataField, name, target.value, label)
                      }
                      value={result}
                    />
                  )
                ) : (
                  <SearchSelectComponent
                    floatingClass="mb-1"
                    labelField={label}
                    placeholder={placeholder || "โปรดเลือก"}
                    noneAsync={noneAsync}
                    queryService={queryService}
                    filterBy={filterBy}
                    options={options || []}
                    isInvalid={required && ["", null].includes(result)}
                    minKeywordLength={minKeywordLength}
                    onChange={(selected) =>
                      handleChange(dataField, name, selected?.value || null)
                    }
                    value={`${result}`}
                  />
                )}
              </Col>
            );
          }
        )}
      </Row>
    );
  };

  const cardMedia = ({ header, button, type, accept }) => {
    return (
      <CardDisplayComponent
        header={{
          className: "d-flex justify-content-between",
          title: { text: header },
          element: (
            <MediaUploader
              accept={accept}
              buttonIcon={AddIcon}
              buttonName={button?.name}
              onSubmitCallbackMedia={({ files }) =>
                setUploadFile((prev) => ({
                  ...prev,
                  [type]:
                    files.length > 0
                      ? [
                          ...prev[type],
                          ...files.filter(
                            (file) =>
                              !uploadFile?.[type].some(
                                (image) => image.name === file.name
                              )
                          )
                        ]
                      : uploadFile?.[type].filter((img) =>
                          data.Media[type].some(
                            (media) => img.name === media.File_Path
                          )
                        )
                }))
              }
            />
          )
        }}
        body={{
          className: "d-flex align-items-center overflow-x-auto",
          element: (
            <MediaPreviewer
              deletedBtn
              mediaType={type}
              loading={loading}
              filePreview={filteredIndex(uploadFile?.[type], "name")}
              onDeleteCallback={handleDeleteFileMedia}
            />
          )
        }}
      />
    );
  };

  const cardInputCheck = ({ header, input, type, inputSearch }) => {
    return (
      <CardDisplayComponent
        header={{ title: { text: header } }}
        body={{
          element: (
            <>
              <Row>
                {input.map(({ name, label }, idx) => (
                  <Col key={idx} sm={1} className="w-auto">
                    <FormCheckComponent
                      id={name}
                      name="list"
                      type={type}
                      label={label}
                      className={{
                        check: "py-3 d-flex",
                        input: "me-3",
                        label: "w-auto"
                      }}
                      onChange={({ target }) =>
                        handleChange(
                          "Inform",
                          name,
                          target.checked ? label : null
                        )
                      }
                      checked={rowInform?.[name] === label}
                      style={{ input: { cursor: "pointer" } }}
                    />
                  </Col>
                ))}
              </Row>
              {inputSearch && inputSearch}
            </>
          )
        }}
      />
    );
  };

  const serviceRequest = (serviceMethod, setDataRequest) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: serviceMethod,
      callback: (res) => setDataRequest(res?.items || res)
    });
  };

  const getFileUpload = (destination, filename, type) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.getFileUploads(destination, filename),
      callback: (res) => {
        const splitFileName = filename.split(".");
        const blobType =
          type === "PDF"
            ? "application/pdf"
            : `${type}/${splitFileName?.[splitFileName?.length - 1]}`;
        const blob = new Blob([res], { type: blobType });
        blob.name = filename;
        setUploadFile((prev) =>
          type === "PDF"
            ? { ...prev, [type]: { blob } }
            : { ...prev, [type]: [...prev[type], blob] }
        );
      }
    });
  };

  const handleSearch = (value) => {
    const findedInform = findItemInArray(InformOtherJobs, "Id", value);
    const filteredMedia = findedInform?.InformOtherJobFiles;
    const filtered = {
      Inform: [findedInform],
      Item: findedInform?.ItemOther,
      Job: findedInform?.JobOtherPrice
    };

    const commonFiltered = (type) =>
      filtered?.[type]?.length > 0 ? filtered?.[type] : [defaultData?.[type]];

    serviceRequest(
      CustomersService.getAllCustomers(
        `?keyword=${findedInform?.Customer?.Cus_Code}`
      ),
      setCustomer
    );

    serviceRequest(
      CustomersService.getCustomerBranches(findedInform?.Cus_Id),
      setBranch
    );

    serviceRequest(
      EmployeesService.getAllEmployees(`?keyword=${findedInform?.To_Section}`),
      setTo_Section
    );

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: EmployeesService.getEmployees(findedInform?.Employee_Id),
      callback: (res) => setEmployee_Name([res])
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: EmployeesService.getEmployees(findedInform?.Inform_By_Id),
      callback: (res) => setEmployee_Name2([res])
    });

    serviceRequest(
      EmployeesService.getAllEmployees(
        `?keyword=${findedInform?.Inform_Section}`
      ),
      setDepartment
    );

    serviceRequest(
      CustContractsService.getCustContracts(
        `?keyword=${findedInform?.Contract_No}`
      ),
      setCustContracts
    );

    serviceRequest(
      CustContractItemsService.getCustContractItems(
        `?keyword=${findedInform?.Contract_No}`
      ),
      setCustContractItems
    );

    filtered?.Item?.map((item) => setItems((prev) => [...prev, item?.Item]));

    setData({
      Inform: { Array: commonFiltered("Inform") },
      Item: { Array: commonFiltered("Item") },
      Job: { Array: commonFiltered("Job") },
      Media: {
        Image: filteredMedia?.filter(({ File_Type }) => File_Type === "Image"),
        Video: filteredMedia?.filter(({ File_Type }) => File_Type === "Video")
      }
    });

    // get PDF
    if (findedInform?.Attach_File) {
      getFileUpload("ใบแจ้งงาน/PDF", findedInform?.Attach_File, "PDF");
    }

    // get image
    if (value && !loading) {
      setUploadFile((prev) => ({ ...prev, Image: [], Video: [] }));
      filteredMedia?.map(({ File_Path, File_Type }) =>
        getFileUpload("ใบแจ้งงาน/Media", File_Path.split("/")?.[2], File_Type)
      );
    }
  };

  const handleChange = (field, name, value) => {
    let findCustomer;
    let findEmployee;
    let findContract;

    if (name === "Cus_Id") {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: CustomersService.getCustomerBranches(value),
        callback: (res) => {
          if (res.length > 0) setBranch(res);
          else {
            setBranch(Customer);
            setData((prev) => ({
              ...prev,
              [field]: { Array: [{ ...prev[field].Array[0], BP_Code: value }] }
            }));
          }
        }
      });
      findCustomer = findItemInArray(Customer, "Id", value);
    } else if (name === "Employee_Id") {
      findEmployee = findItemInArray(employee_Name, "Id", value);
    } else if (name === "Contract_No") {
      findContract = findItemInArray(CustContracts, "Contract_No", value);
    }

    const { Cus_Tel1, Cus_Tel2, Cus_ContactName } = findCustomer || "";
    const { Employee_Name, Employee_Surname } = findEmployee || "";
    const {
      Cus_Contract_Tel1,
      Cus_Contract_Name1,
      Cus_Contract_Tel2,
      Sub_Team,
      Project_No
    } = rowInform;

    setData((prev) => ({
      ...prev,
      [field]: {
        Array: [
          {
            ...prev[field].Array[0],
            [name]: value,
            Cus_Contract_Tel1:
              name === "Cus_Id"
                ? Cus_Tel1
                : name === "Cus_Contract_Tel1"
                ? value
                : Cus_Contract_Tel1,
            Cus_Contract_Name1:
              name === "Cus_Id"
                ? Cus_ContactName
                : name === "Cus_Contract_Name1"
                ? value
                : Cus_Contract_Name1,
            Cus_Contract_Tel2:
              name === "Cus_Id"
                ? Cus_Tel2
                : name === "Cus_Contract_Tel2"
                ? value
                : Cus_Contract_Tel2,
            Sub_Team:
              name === "Employee_Id"
                ? `${Employee_Name} ${Employee_Surname}`
                : Sub_Team,
            Project_No:
              name === "Contract_No" ? findContract?.Project_No : Project_No
          }
        ]
      }
    }));
  };

  const handleUploadFilePDF = ({ file, blob }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.createFileUploads("ใบแจ้งงาน/PDF", [
        file
      ]),
      callback: (res) => {
        setUploadFile((prev) => ({ ...prev, PDF: { file, blob } }));
        setData((prev) => ({
          ...prev,
          Inform: {
            Array: [{ ...prev.Inform.Array[0], Attach_File: res.files[0] }]
          }
        }));
      }
    });
  };

  const handleDeleteFileUploadPDF = (filename) => {
    if (!uploadFile.PDF) {
      setData((prev) => ({
        ...prev,
        Inform: { Array: [{ ...prev.Inform.Array[0], Attach_File: null }] }
      }));
    } else {
      deleteServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: FileUploadsService.deleteFileUploads(
          "ใบแจ้งงาน/PDF",
          filename
        )
      });
      setUploadFile((prev) => ({ ...prev, PDF: null }));
      setData((prev) => ({
        ...prev,
        Inform: {
          Array: [{ ...prev.Inform.Array[0], Attach_File: null }]
        }
      }));
    }
  };

  const handleDeleteSubmit = (service) => {
    deleteServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: service
    });
  };

  const handleDeleteTableForm = (data, newData, type) => {
    const findDelId = data.find(
      ({ Id }) => !newData.some((item) => Id === item.Id)
    )?.Id;

    if (editData && findDelId)
      if (type === "Item")
        handleDeleteSubmit(ItemOthersService.deleteItemOthers(findDelId, true));
      else
        handleDeleteSubmit(
          JobOtherPricesService.deleteJobOtherPrices(findDelId, true)
        );
  };

  const handleDeleteFileMedia = (file, mediaType) => {
    const findFile = findItemInArray(
      data.Media?.[mediaType],
      "File_Path",
      "ใบแจ้งงาน/Media/" + file?.name
    );

    if (findFile)
      handleDeleteSubmit(
        InformOtherJobFilesService.deleteInformOtherJobFiles(findFile?.Id)
      );

    setUploadFile((prev) => ({
      ...prev,
      [mediaType]: filteredNoneItemInArray(
        uploadFile?.[mediaType],
        "name",
        file?.name
      )
    }));
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      const { data, uploadFile } = dataCallback;
      onSubmitCallback(data, uploadFile);
    }
  };

  useEffect(() => {
    if (JobType?.length === 0) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: JobTypeService.getAllJobTypes(),
        callback: (res) =>
          setJobType(filteredNoneMultiItemInArray(res, "Id", ["1", "2", "5"]))
      });
    }

    if (JobTypeSub?.length === 0) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: JobTypeSubService.getAllJobTypeSubs(),
        callback: (res) => setJobTypeSub(res)
      });
    }

    if (editData) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: InformOtherJobsService.getAllInformOtherJobs(),
        callback: (res) =>
          setInformOtherJobs(
            filteredNoneMultiItemInArray(res, "Inform_Doc_Status", ["CLOSED"])
          )
      });
    }
    if (state?.searchValue) handleSearch(state?.searchValue);

    const { date, time } = dateTime;
    if (date || time) {
      setData((prev) => ({
        ...prev,
        Inform: {
          Array: [
            {
              ...prev.Inform.Array[0],
              Job_Cus_Date: date ? `${date}T${time || "00:00"}` : null
            }
          ]
        }
      }));
    }
  }, [editData, dateTime]);

  return (
    <>
      <div className={`${PDFPreview ? "d-none" : ""}`}>
        {editData && (
          <CardDisplayComponent
            header={{
              title: { text: "ค้นหาหมายเลขแจ้งงาน", className: "text-center" }
            }}
            body={{
              element: (
                <SearchFilter
                  data={InformOtherJobs}
                  inputField={searchInput}
                  searchCallback={(search) => {
                    if (!search?.[0]?.value) {
                      navigate("/general_job/create", {
                        state: { name: "edit" }
                      });
                    }
                    setUploadFile({ PDF: null, Image: [], Video: [] });
                    handleSearch(search?.[0]?.value);
                  }}
                />
              )
            }}
          />
        )}

        <Form noValidate validated={validated} onSubmit={handleValidated}>
          <CardDisplayComponent
            body={{ element: InputSearch(inputField.Inform, "Inform") }}
          />

          <CardDisplayComponent
            header={{ title: { text: "รายละเอียดสินค้า/อะไหล่/อุปกรณ์" } }}
            body={{
              element: (
                <TableForm
                  data={data.Item.Array}
                  columns={inputField.Item}
                  defaultData={defaultData.Item}
                  duplicateKey={["Item_Id"]}
                  onChangeCallback={(newData, disValue) => {
                    handleDeleteTableForm(data.Item.Array, newData, "Item");
                    setData((prev) => ({
                      ...prev,
                      Item: {
                        Array: newData.map(
                          (
                            {
                              Item_Id,
                              Item_Install_Qty,
                              Item_Price_Per_Unit,
                              ...item
                            },
                            idx
                          ) => {
                            const disData = disValue?.[idx]?.[1]?.data;
                            const searchData =
                              disData?.length > 0 && idx !== newData?.length - 1
                                ? disData
                                : Items;
                            const findItem = findItemInArray(
                              searchData,
                              "Id",
                              Item_Id
                            );
                            return {
                              ...item,
                              Item_Id: Number(Item_Id),
                              Item_Serial: findItem?.Item_PartNo || null,
                              Uom_Unit: findItem?.Unit || null,
                              Item_Install_Qty:
                                formatCurrencyToNumber(Item_Install_Qty),
                              Item_Price_Per_Unit:
                                formatCurrencyToNumber(Item_Price_Per_Unit),
                              Item_Amount: Number(
                                calculator({
                                  num1: Item_Install_Qty,
                                  num2: Item_Price_Per_Unit,
                                  operator: "*"
                                })
                              )
                            };
                          }
                        )
                      }
                    }));
                  }}
                />
              )
            }}
          />

          <CardDisplayComponent
            header={{ title: { text: "รายละเอียดค่าบริการ" } }}
            body={{
              element: (
                <TableForm
                  data={data.Job.Array}
                  columns={inputField.Job}
                  defaultData={defaultData.Job}
                  onChangeCallback={(newData) => {
                    handleDeleteTableForm(data.Job.Array, newData, "Job");
                    setData((prev) => ({
                      ...prev,
                      Job: {
                        Array: newData.map(({ Oth_Price, ...item }) => ({
                          ...item,
                          Oth_Price: formatCurrencyToNumber(Oth_Price)
                        }))
                      }
                    }));
                  }}
                />
              )
            }}
          />

          <CardDisplayComponent
            body={{ element: InputSearch(inputField.Inform5, "Inform") }}
          />

          {cardMedia({
            header: "รูปภาพประกอบ(ลูกค้า) ขนาดไม่เกิน 25 MB",
            button: { name: "เพิ่มรูปภาพ" },
            type: "Image",
            accept: "image/png, image/jpeg, image/jpg"
          })}

          {cardMedia({
            header: "วีดีโอประกอบ (ลูกค้า) ขนาดไม่เกิน 25 MB",
            button: { name: "เพิ่มวีดีโอ" },
            type: "Video",
            accept: "video/mp4"
          })}

          {cardInputCheck({
            header: "Preventive Maintenance",
            input: inputField.Radio,
            type: "radio",
            inputSearch: InputSearch(inputField.Maintenance, "Inform")
          })}

          {cardInputCheck({
            header: "รายละเอียดการทำงาน",
            input: inputField.Checkbox,
            type: "checkbox"
          })}

          <CardDisplayComponent
            footer={{
              className: "text-center",
              element: (
                <>
                  <Button
                    type="submit"
                    variant="success"
                    className="me-2 px-5 py-2 text-dark rounded-pill"
                  >
                    {state?.name === "edit" ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
                  </Button>

                  <ConfirmModal
                    show={showModal}
                    data={{
                      data,
                      uploadFile,
                      stateBranch: findItemInArray(
                        Branch,
                        "Id",
                        rowInform?.[0]?.BP_Code
                      )
                    }}
                    content={editData ? "edit" : "save"}
                    onSubmitCallback={handleSubmit}
                  />
                </>
              )
            }}
          />
        </Form>
      </div>

      <div className={`${!PDFPreview ? "d-none" : ""}`}>
        <CardDisplayComponent
          header={{
            title: {
              text: "แสดงตัวอย่างสร้างใบแจ้งงาน",
              className: "text-center"
            }
          }}
          body={{ element: <PDFPreviewFile pdfFile={uploadFile?.PDF?.blob} /> }}
          footer={{
            className: "text-center border-top-0 bg-transparent",
            element: (
              <Button
                variant="outline-secondary"
                className="px-4 py-2 text-dark rounded-pill"
                onClick={() => setPDFPreview(!PDFPreview)}
              >
                ย้อนกลับ
              </Button>
            )
          }}
        />
      </div>
    </>
  );
};

CreateJobForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default CreateJobForm;
